<template>
  <div class="remoteClient row justify-center">
    <div class="rate column">
      <div class="header row justify-center">
        <img :src="theme.logo" class="logo" />
      </div>
      <div class="content column">
        <div class="row">
          <div>
            <svg
              class="lia"
              width="57"
              height="57"
              viewBox="0 0 47 47"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M31.5205 5.7395C32.4697 5.7395 33.2393 4.96999 33.2393 4.02075C33.2393 3.07151 32.4697 2.302 31.5205 2.302C30.5713 2.302 29.8018 3.07151 29.8018 4.02075C29.8018 4.96999 30.5713 5.7395 31.5205 5.7395Z"
                fill="#EC3E75"
                fill-opacity="0.2"
              />
              <path
                d="M15.4785 5.7395C16.4278 5.7395 17.1973 4.96999 17.1973 4.02075C17.1973 3.07151 16.4278 2.302 15.4785 2.302C14.5293 2.302 13.7598 3.07151 13.7598 4.02075C13.7598 4.96999 14.5293 5.7395 15.4785 5.7395Z"
                fill="#EC3E75"
                fill-opacity="0.2"
              />
              <path
                d="M4.02051 28.6561C3.56482 28.6556 3.12794 28.4743 2.80572 28.1521C2.4835 27.8299 2.30226 27.393 2.30176 26.9373V22.354C2.30226 21.8983 2.4835 21.4614 2.80572 21.1392C3.12794 20.817 3.56482 20.6358 4.02051 20.6353H5.73926V28.6561H4.02051Z"
                fill="#EC3E75"
                fill-opacity="0.2"
              />
              <path
                d="M41.2598 28.6561V20.6353H42.9785C43.4342 20.6358 43.8711 20.817 44.1933 21.1392C44.5155 21.4614 44.6968 21.8983 44.6973 22.354V26.9373C44.6968 27.393 44.5155 27.8299 44.1933 28.1521C43.8711 28.4743 43.4342 28.6556 42.9785 28.6561H41.2598Z"
                fill="#EC3E75"
                fill-opacity="0.2"
              />
              <g filter="url(#filter0_i)">
                <path
                  d="M18.3431 39.5417C18.3439 39.4662 18.3296 39.3914 18.301 39.3215C18.2725 39.2517 18.2304 39.1882 18.177 39.1348C18.1237 39.0815 18.0602 39.0393 17.9903 39.0108C17.9205 38.9823 17.8456 38.968 17.7702 38.9688H10.8952C9.83193 38.9675 8.81258 38.5446 8.06075 37.7928C7.30891 37.0409 6.88599 36.0216 6.88477 34.9583V15.4792C6.88599 14.4159 7.30891 13.3966 8.06075 12.6447C8.81258 11.8929 9.83193 11.47 10.8952 11.4688H36.1035C37.1668 11.47 38.1861 11.893 38.9379 12.6448C39.6897 13.3966 40.1126 14.4159 40.1139 15.4792V34.9583C40.1126 36.0216 39.6897 37.0409 38.9379 37.7927C38.1861 38.5445 37.1668 38.9675 36.1035 38.9688H26.9369C26.8254 38.9701 26.7165 39.0018 26.6217 39.0604L18.3431 44.2363V39.5417ZM15.4785 29.2269C15.3491 29.2275 15.2237 29.2717 15.1225 29.3525C15.0214 29.4332 14.9505 29.5458 14.9213 29.6718C14.8921 29.7979 14.9064 29.9302 14.9618 30.0471C15.0172 30.1641 15.1104 30.2589 15.2264 30.3163C17.8127 31.5324 20.6417 32.1442 23.4994 32.1052C26.3573 32.1441 29.1866 31.5323 31.7731 30.316C31.8887 30.2584 31.9816 30.1635 32.0366 30.0466C32.0917 29.9297 32.1057 29.7977 32.0765 29.6719C32.0472 29.546 31.9764 29.4337 31.8755 29.3531C31.7745 29.2724 31.6494 29.2282 31.5202 29.2274C31.4328 29.2276 31.3467 29.2485 31.269 29.2884C28.8397 30.4258 26.1837 30.9963 23.5016 30.9568C20.819 30.996 18.1625 30.426 15.7323 29.2896C15.6539 29.2488 15.5669 29.2274 15.4785 29.2269ZM29.2285 18.3438C29.6842 18.3443 30.1211 18.5255 30.4433 18.8477C30.7655 19.1699 30.9468 19.6068 30.9473 20.0625C30.9473 20.2144 31.0076 20.3602 31.1151 20.4676C31.2225 20.5751 31.3682 20.6354 31.5202 20.6354C31.6721 20.6354 31.8179 20.5751 31.9253 20.4676C32.0327 20.3602 32.0931 20.2144 32.0931 20.0625C32.0931 19.3028 31.7913 18.5741 31.2541 18.0369C30.7169 17.4997 29.9883 17.1979 29.2285 17.1979C28.4688 17.1979 27.7402 17.4997 27.203 18.0369C26.6657 18.5741 26.3639 19.3028 26.3639 20.0625C26.3639 20.2144 26.4243 20.3602 26.5317 20.4676C26.6392 20.5751 26.7849 20.6354 26.9369 20.6354C27.0888 20.6354 27.2345 20.5751 27.342 20.4676C27.4494 20.3602 27.5098 20.2144 27.5098 20.0625C27.5103 19.6068 27.6915 19.1699 28.0137 18.8477C28.336 18.5255 28.7728 18.3443 29.2285 18.3438ZM17.7702 18.3438C18.2259 18.3443 18.6628 18.5255 18.985 18.8477C19.3072 19.1699 19.4884 19.6068 19.4889 20.0625C19.4889 20.2144 19.5493 20.3602 19.6567 20.4676C19.7642 20.5751 19.9099 20.6354 20.0619 20.6354C20.2138 20.6354 20.3595 20.5751 20.467 20.4676C20.5744 20.3602 20.6348 20.2144 20.6348 20.0625C20.6348 19.3028 20.333 18.5741 19.7958 18.0369C19.2585 17.4997 18.5299 17.1979 17.7702 17.1979C17.0104 17.1979 16.2818 17.4997 15.7446 18.0369C15.2074 18.5741 14.9056 19.3028 14.9056 20.0625C14.9056 20.2144 14.966 20.3602 15.0734 20.4676C15.1808 20.5751 15.3266 20.6354 15.4785 20.6354C15.6305 20.6354 15.7762 20.5751 15.8836 20.4676C15.9911 20.3602 16.0514 20.2144 16.0514 20.0625C16.0519 19.6068 16.2332 19.1699 16.5554 18.8477C16.8776 18.5255 17.3145 18.3443 17.7702 18.3438Z"
                  fill="#EC3E75"
                  fill-opacity="0.3"
                />
              </g>
              <path
                d="M15.4788 21.2083C15.6295 21.2089 15.7787 21.1796 15.918 21.1222C16.0572 21.0648 16.1837 20.9804 16.2902 20.8739C16.3967 20.7674 16.4811 20.6409 16.5385 20.5016C16.5959 20.3624 16.6252 20.2131 16.6247 20.0625C16.6247 19.7586 16.7454 19.4672 16.9603 19.2523C17.1752 19.0374 17.4666 18.9167 17.7705 18.9167C18.0744 18.9167 18.3659 19.0374 18.5807 19.2523C18.7956 19.4672 18.9163 19.7586 18.9163 20.0625C18.9163 20.3664 19.0371 20.6578 19.252 20.8727C19.4668 21.0876 19.7583 21.2083 20.0622 21.2083C20.3661 21.2083 20.6575 21.0876 20.8724 20.8727C21.0873 20.6578 21.208 20.3664 21.208 20.0625C21.208 19.1508 20.8459 18.2765 20.2012 17.6318C19.5565 16.9872 18.6822 16.625 17.7705 16.625C16.8588 16.625 15.9845 16.9872 15.3398 17.6318C14.6952 18.2765 14.333 19.1508 14.333 20.0625C14.3325 20.2131 14.3618 20.3624 14.4192 20.5016C14.4766 20.6409 14.561 20.7674 14.6675 20.8739C14.774 20.9804 14.9005 21.0648 15.0397 21.1222C15.179 21.1796 15.3282 21.2089 15.4788 21.2083Z"
                fill="#EC3E75"
              />
              <path
                d="M31.0101 28.7765C26.7304 30.9192 20.2736 30.9192 15.9882 28.7765C15.7162 28.6413 15.4016 28.6196 15.1137 28.7163C14.8258 28.813 14.588 29.0201 14.4528 29.2921C14.3175 29.5641 14.2959 29.8787 14.3926 30.1666C14.4893 30.4546 14.6964 30.6923 14.9684 30.8275C17.634 32.0858 20.5518 32.7188 23.4991 32.6781C26.4465 32.7188 29.3643 32.0858 32.0299 30.8275C32.3018 30.6923 32.509 30.4546 32.6057 30.1666C32.7024 29.8787 32.6807 29.5641 32.5455 29.2921C32.4102 29.0201 32.1725 28.813 31.8846 28.7163C31.5966 28.6196 31.2821 28.6413 31.0101 28.7765Z"
                fill="#EC3E75"
              />
              <path
                d="M42.9788 18.9166H41.833V15.4791C41.8325 13.9598 41.2287 12.5029 40.1544 11.4286C39.0801 10.3543 37.6231 9.75047 36.1038 9.74992H32.6663V7.24628C33.4309 6.97598 34.0752 6.44411 34.4855 5.74468C34.8958 5.04525 35.0456 4.2233 34.9085 3.42408C34.7714 2.62487 34.3561 1.89986 33.7362 1.3772C33.1162 0.854535 32.3314 0.567871 31.5205 0.567871C30.7096 0.567871 29.9248 0.854535 29.3049 1.3772C28.6849 1.89986 28.2696 2.62487 28.1325 3.42408C27.9954 4.2233 28.1452 5.04525 28.5555 5.74468C28.9658 6.44411 29.6102 6.97598 30.3747 7.24628V9.74992H16.6247V7.24628C17.3892 6.97598 18.0335 6.44411 18.4438 5.74468C18.8541 5.04525 19.004 4.2233 18.8668 3.42408C18.7297 2.62487 18.3145 1.89986 17.6945 1.3772C17.0745 0.854535 16.2897 0.567871 15.4788 0.567871C14.6679 0.567871 13.8832 0.854535 13.2632 1.3772C12.6432 1.89986 12.228 2.62487 12.0908 3.42408C11.9537 4.2233 12.1036 5.04525 12.5138 5.74468C12.9241 6.44411 13.5685 6.97598 14.333 7.24628V9.74992H10.8955C9.3765 9.75144 7.92015 10.3555 6.84605 11.4296C5.77195 12.5037 5.16786 13.9601 5.16634 15.4791V18.9166H4.02051C3.10905 18.9173 2.23513 19.2797 1.59063 19.9242C0.946134 20.5687 0.583736 21.4426 0.583008 22.3541V26.9374C0.583736 27.8489 0.946134 28.7228 1.59063 29.3673C2.23513 30.0118 3.10905 30.3742 4.02051 30.3749H5.16634V34.9583C5.16786 36.4773 5.77195 37.9336 6.84605 39.0077C7.92015 40.0818 9.3765 40.6859 10.8955 40.6874H16.6247V45.2708C16.6252 45.4751 16.6802 45.6757 16.7841 45.8517C16.8879 46.0277 17.0369 46.1728 17.2155 46.272C17.3942 46.3713 17.5961 46.4211 17.8004 46.4163C18.0047 46.4115 18.204 46.3522 18.3778 46.2447L27.2637 40.6874H36.1038C37.6231 40.6869 39.0801 40.0831 40.1544 39.0088C41.2287 37.9345 41.8325 36.4776 41.833 34.9583V30.3749H42.9788C43.8903 30.3742 44.7642 30.0118 45.4087 29.3673C46.0532 28.7228 46.4156 27.8489 46.4163 26.9374V22.3541C46.4156 21.4426 46.0532 20.5687 45.4087 19.9242C44.7642 19.2797 43.8903 18.9173 42.9788 18.9166ZM5.16634 28.0833H4.02051C3.71689 28.0824 3.42596 27.9614 3.21127 27.7467C2.99657 27.532 2.87557 27.241 2.87467 26.9374V22.3541C2.87557 22.0505 2.99657 21.7595 3.21127 21.5448C3.42596 21.3302 3.71689 21.2091 4.02051 21.2083H5.16634V28.0833ZM31.5205 2.87492C31.7471 2.87492 31.9687 2.94212 32.1571 3.06803C32.3455 3.19394 32.4924 3.37289 32.5791 3.58226C32.6658 3.79164 32.6885 4.02203 32.6443 4.2443C32.6001 4.46657 32.491 4.67073 32.3307 4.83098C32.1705 4.99123 31.9663 5.10036 31.7441 5.14457C31.5218 5.18878 31.2914 5.16609 31.082 5.07937C30.8726 4.99264 30.6937 4.84578 30.5678 4.65735C30.4419 4.46892 30.3747 4.24738 30.3747 4.02076C30.3756 3.71714 30.4966 3.42621 30.7113 3.21151C30.926 2.99682 31.2169 2.87581 31.5205 2.87492ZM15.4788 2.87492C15.7055 2.87492 15.927 2.94212 16.1154 3.06803C16.3039 3.19394 16.4507 3.37289 16.5375 3.58226C16.6242 3.79164 16.6469 4.02203 16.6027 4.2443C16.5584 4.46657 16.4493 4.67073 16.2891 4.83098C16.1288 4.99123 15.9247 5.10036 15.7024 5.14457C15.4801 5.18878 15.2497 5.16609 15.0404 5.07937C14.831 4.99264 14.652 4.84578 14.5261 4.65735C14.4002 4.46892 14.333 4.24738 14.333 4.02076C14.3339 3.71714 14.4549 3.42621 14.6696 3.21151C14.8843 2.99682 15.1752 2.87581 15.4788 2.87492ZM39.5413 34.9583C39.5406 35.8697 39.1782 36.7436 38.5337 37.3881C37.8892 38.0326 37.0153 38.395 36.1038 38.3958H26.9372C26.7229 38.3971 26.5131 38.4565 26.3299 38.5676L18.9163 43.2025V39.5416C18.9169 39.391 18.8876 39.2417 18.8302 39.1025C18.7728 38.9632 18.6884 38.8367 18.5819 38.7302C18.4754 38.6237 18.3489 38.5393 18.2096 38.4819C18.0704 38.4245 17.9211 38.3952 17.7705 38.3958H10.8955C9.98405 38.395 9.11013 38.0326 8.46563 37.3881C7.82113 36.7436 7.45874 35.8697 7.45801 34.9583V15.4791C7.45874 14.5676 7.82113 13.6937 8.46563 13.0492C9.11013 12.4047 9.98405 12.0423 10.8955 12.0416H36.1038C37.0153 12.0423 37.8892 12.4047 38.5337 13.0492C39.1782 13.6937 39.5406 14.5676 39.5413 15.4791V34.9583ZM44.1247 26.9374C44.1238 27.241 44.0028 27.532 43.7881 27.7467C43.5734 27.9614 43.2825 28.0824 42.9788 28.0833H41.833V21.2083H42.9788C43.2825 21.2091 43.5734 21.3302 43.7881 21.5448C44.0028 21.7595 44.1238 22.0505 44.1247 22.3541V26.9374Z"
                fill="#EC3E75"
              />
              <path
                d="M29.2285 16.625C28.3171 16.6257 27.4431 16.9881 26.7986 17.6326C26.1541 18.2771 25.7917 19.151 25.791 20.0625C25.791 20.3664 25.9117 20.6578 26.1266 20.8727C26.3415 21.0876 26.633 21.2083 26.9368 21.2083C27.2407 21.2083 27.5322 21.0876 27.7471 20.8727C27.962 20.6578 28.0827 20.3664 28.0827 20.0625C28.0827 19.7586 28.2034 19.4672 28.4183 19.2523C28.6332 19.0374 28.9246 18.9167 29.2285 18.9167C29.5324 18.9167 29.8239 19.0374 30.0387 19.2523C30.2536 19.4672 30.3743 19.7586 30.3743 20.0625C30.3743 20.3664 30.4951 20.6578 30.71 20.8727C30.9248 21.0876 31.2163 21.2083 31.5202 21.2083C31.8241 21.2083 32.1155 21.0876 32.3304 20.8727C32.5453 20.6578 32.666 20.3664 32.666 20.0625C32.6653 19.151 32.3029 18.2771 31.6584 17.6326C31.0139 16.9881 30.14 16.6257 29.2285 16.625Z"
                fill="#EC3E75"
              />
              <defs>
                <filter
                  id="filter0_i"
                  x="6.88477"
                  y="11.4688"
                  width="33.2292"
                  height="36.7676"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                  />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.92549 0 0 0 0 0.243137 0 0 0 0 0.458824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow"
                  />
                </filter>
              </defs>
            </svg>
          </div>

          <div class="title">
            Avalie seu atendimento com
            {{ user.genero_bot_km + " " + user.nome_bot_km }}
          </div>
        </div>
        <div v-if="!ok" class="solve column align-center">
          Seu problema foi resolvido?
          <div class="vote row justify-space align-center">
            <div :class="problem ? 'active' : 'op'" @click="problem = true">
              SIM
            </div>
            <div :class="!problem ? 'active' : 'op'" @click="problem = false">
              NÃO
            </div>
          </div>
        </div>
        <div v-if="!ok" class="stars column align-center">
          <div class="text-center">Como você avalia o atendimento?</div>
          <div class="row">
            <div class="star" v-for="(star, i) in stars" :key="i">
              <svg
                v-if="!star.vote"
                @mouseover="hover(i)"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5095 6.58604L13.0546 5.79327L10.6161 0.849715C10.5495 0.714363 10.44 0.604793 10.3046 0.538192C9.96516 0.370613 9.55266 0.510262 9.38294 0.849715L6.94446 5.79327L1.48958 6.58604C1.33919 6.60753 1.20169 6.67843 1.09641 6.78585C0.969142 6.91666 0.899011 7.09265 0.901428 7.27514C0.903845 7.45763 0.978613 7.6317 1.1093 7.75909L5.05598 11.6069L4.12356 17.0403C4.10169 17.1667 4.11568 17.2967 4.16393 17.4156C4.21219 17.5344 4.29277 17.6374 4.39656 17.7127C4.50034 17.7881 4.62317 17.8329 4.75112 17.842C4.87906 17.8512 5.00701 17.8243 5.12044 17.7644L9.99954 15.1991L14.8786 17.7644C15.0118 17.8353 15.1665 17.8589 15.3148 17.8331C15.6886 17.7687 15.94 17.4142 15.8755 17.0403L14.9431 11.6069L18.8898 7.75909C18.9972 7.65382 19.0681 7.51632 19.0896 7.36593C19.1476 6.98995 18.8855 6.6419 18.5095 6.58604Z"
                  fill="#F2F2F2"
                />
              </svg>
              <svg
                v-else
                @click="
                  click = true;
                  hover(i, true);
                "
                @mouseleave="reset()"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5095 6.58604L13.0546 5.79327L10.6161 0.849715C10.5495 0.714363 10.44 0.604793 10.3046 0.538192C9.96516 0.370613 9.55266 0.510262 9.38294 0.849715L6.94446 5.79327L1.48958 6.58604C1.33919 6.60753 1.20169 6.67843 1.09641 6.78585C0.969142 6.91666 0.899011 7.09265 0.901428 7.27514C0.903845 7.45763 0.978613 7.6317 1.1093 7.75909L5.05598 11.6069L4.12356 17.0403C4.10169 17.1667 4.11568 17.2967 4.16393 17.4156C4.21219 17.5344 4.29277 17.6374 4.39656 17.7127C4.50034 17.7881 4.62317 17.8329 4.75112 17.842C4.87906 17.8512 5.00701 17.8243 5.12044 17.7644L9.99954 15.1991L14.8786 17.7644C15.0118 17.8353 15.1665 17.8589 15.3148 17.8331C15.6886 17.7687 15.94 17.4142 15.8755 17.0403L14.9431 11.6069L18.8898 7.75909C18.9972 7.65382 19.0681 7.51632 19.0896 7.36593C19.1476 6.98995 18.8855 6.6419 18.5095 6.58604Z"
                  fill="#EC3E75"
                />
              </svg>
            </div>
          </div>
          <div class="text">{{ text }}</div>
          <br /><br />
          <Button layout="remote-continue" :disabled="submit" @click="goRate"
            >AVALIAR ATENDIMENTO</Button
          >
        </div>
        <div v-if="ok" class="ok">
          <span>Avaliação gravada com sucesso!</span><br /><br /><br />Obrigado.
        </div>
      </div>
    </div>

    <Status />
  </div>
</template>

<script>
// Depois integrar com tema dinamico
const theme = "vero";
import themes from "@/conf/themes.js";
if (theme === "vero") {
  require("../../../../public/theme/vero/style-vero.scss");
} else {
  require("../../../../public/theme/ns/style-ns.scss");
}

import Status from "@/components/Status.vue";
import Button from "@/components/Button.vue";
import { mapActions } from "vuex";

export default {
  name: "RemoteClient",
  components: {
    Status,
    Button,
  },
  data() {
    return {
      ok: false,
      submit: true,
      problem: true,
      theme: themes[theme],
      stars: {
        0: { vote: false, text: "Muito ruim" },
        1: { vote: false, text: "Ruim" },
        2: { vote: false, text: "Normal" },
        3: { vote: false, text: "Bom" },
        4: { vote: false, text: "Muito bom" },
      },
      text: "",
      click: false,
      aux: {},
      rate: {},
      countStars: 0,
    };
  },
  beforeMount() {
    let token = window.location.toString().split("avaliacao=")[1];
    this.GET_RATE(token).then((r) => (this.rate = r));
  },
  methods: {
    ...mapActions("general", ["GET_RATE", "SET_RATE"]),
    goRate() {
      this.rate.doutores[0].problema_resolvido = this.problem;
      this.rate.doutores[0].nota = this.countStars;
      this.SET_RATE(this.rate).then((r) => {
        if (r.status == 200) this.ok = true;
      });
    },
    reset(force) {
      if (force || !this.click) {
        this.countStars = 0;
        this.text = "";
        this.stars = {
          0: { vote: false, text: "Muito ruim" },
          1: { vote: false, text: "Ruim" },
          2: { vote: false, text: "Normal" },
          3: { vote: false, text: "Bom" },
          4: { vote: false, text: "Muito bom" },
        };
      }

      if (this.click && !force) this.stars = this.aux;
    },
    hover(n, click) {
      this.aux = this.stars;
      this.reset(true);
      for (let i = 0; i <= n; i++)
        (this.stars[i].vote = true),
          (this.text = this.stars[i].text),
          this.countStars++;

      if (click) {
        this.aux = this.stars;
        this.submit = false;
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;500;600&display=swap");
body {
  background: #fff;
}
</style>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.rate {
  color: 373946;
  font-family: Work Sans;
  background: #fff;
  padding: 20px;
  width: 320px;
  .header {
    margin-top: 10%;
    height: 70px;
    border-radius: 10px;
  }
  .content {
    margin-top: 10px;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 45px;
    .lia {
      margin-right: 19px;
    }
    .title {
      font-weight: 600;
      font-size: 25px;
      line-height: 23px;
    }
    .solve {
      font-size: 14px;
      margin-top: 35px;
      font-weight: 300;
      .vote {
        background: rgba(0, 0, 0, 0.05);
        color: rgba(0, 0, 0, 0.3);
        border-radius: 48px;
        height: 45px;
        font-size: 14px;
        font-weight: normal;
        padding: 0px 4px;
        width: 137px;
        margin-top: 10px;
        .op {
          border-radius: 48px;
          padding: 9px 20px;
          cursor: pointer;
          text-align: center;
          &:hover {
            color: #777;
            font-weight: bold;
          }
        }
      }
    }
    .stars {
      font-size: 14px;
      margin-top: 35px;
      font-weight: 300;
      .star {
        margin-top: 15px;
        svg {
          cursor: pointer;
          margin-right: 7px;
        }
      }
      .text {
        font-weight: bold;
        height: 20px;
      }
    }
    .ok {
      margin-top: 45px;
      text-align: center;
      color: $gray-6;
      span {
        color: $green-2;
      }
    }
  }
}
</style>
